export enum GamTabSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
